"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrustIndex = void 0;
/**
 * Index for node type (full validator, basic validator or watcher node)
 */
class TrustIndex {
    constructor(network) {
        this._network = network;
    }
    get(node) {
        let vertex = this._network.nodesTrustGraph.getVertex(node.publicKey);
        if (!vertex)
            return 0;
        return (Array.from(this._network.nodesTrustGraph.getParents(vertex))
            .filter((trustingVertex) => trustingVertex.key !== vertex.key).length)
            /
                (Array.from(this._network.nodesTrustGraph.vertices.values()).filter(vertex => this._network.nodesTrustGraph.getOutDegree(vertex) > 0).length - 1); //exclude the node itself
    }
}
exports.TrustIndex = TrustIndex;
//# sourceMappingURL=trust-index.js.map